import { setActiveSchema } from '@/document-engine/application/active-schema'
import { negotiationVariableSchemaProvider } from '@/features/negotiations/document-binding/negotiation-variable-schema'

/**
 * Composition root del motor documental.
 *
 * El esquema se inyecta una sola vez al arrancar la aplicación para que TODOS los
 * consumidores (editor, impresión y validación) compartan el mismo catálogo. Antes
 * se inicializaba dentro de dos páginas del editor; entrar directo a "Imprimir"
 * dejaba el engine con EMPTY_SCHEMA y clasificaba cualquier variable vacía como typo.
 */
export const setupDocumentEngine = (): void => {
  setActiveSchema(negotiationVariableSchemaProvider.getSchema())
}
